import { Market } from "models/regions"
import { http } from "./http"
import { Paginated } from "./types"

export const fetchCurrentMarket = async (_key: string) => {
  const res = await http.get("markets/current").json()
  return res as Market
}

export const fetchMarkets = async () => {
  const res = await http.get("markets").json()
  return res as Paginated<Market>
}

export const patchCurrentMarket = async (pld: Partial<Market>) => {
  const { id, ...json } = pld
  const res = await http.patch(`markets/${id}`, { json }).json()

  return res as Market
}

export const executeMarketInitialization = async (file: File) => {
  const body = new FormData()
  body.append("file", file)

  return http.post("v2/market-init/execute", { body })
}

export const validateMarket = async (file: File) => {
  const body = new FormData()
  body.append("file", file)

  return http.post("v2/market-init/validate", { body })
}
